<template>
    <form-row title="Have You Wired Your Funds to the Title Company?">
        <input-radio-boolean
            name="have_you_wired_funds"
            :value="closing.have_you_wired_funds"
            true="Yes"
            false="No"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        closing: {},
        read_only: { default: false },
    },
}
</script>
